import { Text } from "@aws-amplify/ui-react";
import { CookieStorage, I18n } from "aws-amplify/utils";
import { useEffect } from "react";
import { strings } from "../strings";
import { signOut } from "aws-amplify/auth";
import BasicLayout from "../components/basicLayout";

I18n.putVocabularies(strings);

const Logout = () => {
	useEffect(async () => {
		const redirectToRedirectUri = async () => {
			const cookieStoreage = new CookieStorage({
				domain: ".cosmogas.com",
				sameSite: "none",
				secure: true,
			});

			await cookieStoreage.removeItem("access_token");
			await cookieStoreage.removeItem("id_token");
			await cookieStoreage.removeItem("refresh_token");
			await cookieStoreage.removeItem("userEmail");

			const queryParams = new URLSearchParams(window.location.search);
			const redirect_uri = queryParams.get("redirect_uri");
			window.location.href = redirect_uri;
		};

		signOut()
			.then(redirectToRedirectUri)
			.catch((e) => {
				console.log("Something went wrong during logout", e);
				redirectToRedirectUri();
			});
	}, []);

	return (
		<BasicLayout>
			<div
				style={{
					display: "flex",
					flexDirection: "column",
					alignItems: "stretch",
				}}
			>
				<Text headingLevel={1} marginBottom={"20px"} textAlign={"center"}>
					{"Logging out..."}
				</Text>
			</div>
		</BasicLayout>
	);
};

export default Logout;
